module.exports = __webpack_public_path__ + "img/Provincie-Zuid-Holland.224a2ed8.svg";